import { useToast } from "@src/appV2/lib/Notifications/Toasts/useToast";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time. See https://www.notion.so/BP-Date-Time-2ef8643321f48032ad80e8a5b30aa278 for more information
import { format, isBefore, startOfDay } from "date-fns";
import { type ReactElement } from "react";

import { useWorkerAvailabilityContext } from "../../context";
import { AvailabilityCalendarCellStatus } from "../../types";
import { getAvailableDatesFromCurrentDates } from "../../utils";
import { AvailabilityCalendar } from "../WorkerAvailabilityCalendar/Calendar";

export interface WorkerAvailabilityFormProps {
  isSubmitting: boolean;
  currentDate: Date;
}

export function WorkerAvailabilityForm(props: WorkerAvailabilityFormProps): ReactElement {
  const { isSubmitting, currentDate } = props;

  const { showInfoToast } = useToast();
  const { setModifiedDates, currentDates, modifiedDates, alreadyBookedDates, isLoading } =
    useWorkerAvailabilityContext();

  return (
    <AvailabilityCalendar
      isLoading={isSubmitting || isLoading}
      currentDate={currentDate}
      availableDates={getAvailableDatesFromCurrentDates(currentDates)}
      blockedDates={alreadyBookedDates}
      onDateSelect={(params) => {
        const { id, value, isSelected, isDisabled } = params;
        const isPastDate = isBefore(value, startOfDay(new Date()));

        if (isPastDate) {
          return;
        }

        if (isDisabled) {
          showInfoToast(`You are working on ${format(value, "PPP")}.`);
          return;
        }

        setModifiedDates({
          ...modifiedDates,
          [id]: isSelected
            ? AvailabilityCalendarCellStatus.UNAVAILABLE
            : AvailabilityCalendarCellStatus.AVAILABLE,
        });
      }}
    />
  );
}
